import IndividualSummaryAPIResponse from "marketplace/individuals/profiles/summaries/_api/responses/individual-summary-api-response";
import IndividualSummary from "marketplace/individuals/profiles/summaries/individual-summary";

export default class IndividualSummariesAPIResponse {
  public individuals?: IndividualSummaryAPIResponse[];

  public deserialize(): IndividualSummary[] {
    if (!Array.isArray(this.individuals)) throw new Error("Individual Summaries not returned from API");
    return this.individuals.map(individual => individual.deserialize());
  }
}
